import { render, staticRenderFns } from "./MemberPackageEdit.vue?vue&type=template&id=b18e8f46&scoped=true&"
import script from "./MemberPackageEdit.vue?vue&type=script&lang=js&"
export * from "./MemberPackageEdit.vue?vue&type=script&lang=js&"
import style0 from "./MemberPackageEdit.vue?vue&type=style&index=0&id=b18e8f46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e8f46",
  null
  
)

export default component.exports